module.exports = __webpack_public_path__ + "img/Colorize01.e36ae12f.png";